import { useGetters, useMutations } from '@/utils/mapStore';
import { computed, watch } from 'vue';

const getAmount = () => {
  //取得資料
  const { getOrderAmount, getPaidList } = useGetters('checkout', ['getOrderAmount', 'getPaidList']);
  const getDayungsPayment = useGetters('member', ['getDayungsPayment']);
  const getMemberInformation = useGetters('member', ['getMemberInformation']);
  //----------金額相關----------//
  //已收
  const computePaid = computed(() => {
    if (getPaidList.value?.length > 0) return getPaidList.value.map((e) => e.amount).reduce((total, e) => total + e);
    else return 0;
  });
  //未收
  const computeUnpaid = computed(() => {
    const number = getOrderAmount.value - computePaid.value;
    return number < 0 ? 0 : number;
  });
  //找零
  const change = computed(() => {
    const number = computePaid.value - getOrderAmount.value;
    return number < 0 ? 0 : number;
  });
  //大苑子支付顯示餘額(旺卡、現金卡、黃金點數)
  const getBalance = (type) => {
    const real_balance = getDayungsPayment.value[type].balance;
    const index = getPaidList.value.findIndex((e) => e.payment_type === type);
    const amount = index > -1 ? getPaidList.value[index].amount : 0;
    return real_balance - amount;
  };
  //未收=0時開啟結帳按鈕
  const SET_CHECKOUT_VALID = useMutations('checkout', ['SET_CHECKOUT_VALID']);
  watch(
    computeUnpaid,
    () => {
      if (computeUnpaid.value <= 0) {
        SET_CHECKOUT_VALID(true);
      }
      else {
        //判斷是不是付款方式有採用旺卡，且為自動加值
        //使用有自動加值的旺卡付款時直接開啟結帳按鈕
        const isUseWantCard = getPaidList.value?.some((item) => {
          return item.payment_type === 'want_card';
        });
        if (isUseWantCard && getMemberInformation.value?.want_card_card_link) {
          SET_CHECKOUT_VALID(true);
        }
        else {
          SET_CHECKOUT_VALID(false);
        }
      }
    },
    { immediate: true }
  );
  watch(
    getPaidList,
    () => {
      //使用有自動加值的旺卡付款時直接開啟結帳按鈕
      const isUseWantCard = getPaidList.value?.some((item) => {
        return item.payment_type === 'want_card';
      });
      if (isUseWantCard && getMemberInformation.value?.want_card_card_link) SET_CHECKOUT_VALID(true);
    },
    { deep: true }
  );
  return { computePaid, computeUnpaid, change, getBalance };
};
export { getAmount };
